/* Keep a short rich-text note readable without truncating markup or link URLs. */
if (!customElements.get('dtz-short-note')) {
  customElements.define('dtz-short-note', class extends HTMLElement {
    connectedCallback() {
      const template = this.querySelector('template');
      const output = this.querySelector('[data-note-output]');
      if (!template || !output) return;
      const content = template.content.cloneNode(true);
      const limit = Number(this.dataset.wordLimit) || 40;
      const words = [...content.textContent.matchAll(/\S+/gu)];
      if (words.length > limit) {
        // Work in text offsets, not HTML, so links and emphasis spanning the cutoff stay valid.
        const cutoff = words[limit - 1].index + words[limit - 1][0].length;
        const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
        let remaining = cutoff;
        let node;
        while ((node = walker.nextNode())) {
          if (remaining <= node.textContent.length) {
            const range = document.createRange();
            range.setStart(node, remaining);
            range.setEnd(content, content.childNodes.length);
            range.deleteContents();
            break;
          }
          remaining -= node.textContent.length;
        }
        content.append(document.createTextNode('…'));
      }
      output.replaceChildren(content);
    }
  });
}
